import { render, staticRenderFns } from "./bankInsure.vue?vue&type=template&id=3d48f72c&scoped=true"
import script from "./bankInsure.vue?vue&type=script&lang=js"
export * from "./bankInsure.vue?vue&type=script&lang=js"
import style0 from "./bankInsure.vue?vue&type=style&index=0&id=3d48f72c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48f72c",
  null
  
)

export default component.exports